export const StorageConstants = {
    LOGIN_TIME: '@recruiter-login-time',
    LOGIN_TOKEN: '@recruiter-login-token',
    SIGNUP_TOKEN: '@recruiter-signup-token',
    USED_ID: '@recruiter-user-id',
    USER_NAME: '@recruiter-user-name',
    MOBILE_NUMBER: '@recruiter-mobile-number',
}